// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".newsletter-list li[data-v-6a10d27c]:before{content:url(/images/svg/check.svg)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
